import inView from 'in-view';
import React, { createElement } from 'react';
import { startCase, has } from 'lodash';
import marksy from 'marksy/jsx';

import {
  NewsletterSmall,
  RelatedArticle,
  Iframe,
  BlogLink,
  BlogQuoteAuthor,
} from 'components';

export const isResolution = breakpoint =>
  (typeof window !== 'undefined' && window.innerWidth > breakpoint) === false;

export const enableAnimations = () => {
  inView('.anim-fade-in').on('enter', el => {
    el.classList.add('is-inview');
  });

  inView('.anim-fade-in-bottom').on('enter', el => {
    el.classList.add('is-inview');
  });

  inView('.anim-fade-in-left').on('enter', el => {
    el.classList.add('is-inview');
  });
};

export const getImageAlt = _fileName => {
  let fileName = _fileName;

  if (typeof _fileName === 'object' && _fileName.base64) {
    fileName = _fileName.base64;
  }

  if (fileName.includes('data:image')) {
    return '';
  }

  return startCase(
    fileName
      .split('/')
      .pop()
      .replace(/\.[^/.]+$/, ''),
  );
};

export const getArticleSlug = post => {
  const { frontmatter, fields } = post.node;
  const { templateKey, settings } = frontmatter;

  const availableSlugs = {
    'article-page': 'blog',
    'case-study-page': 'work',
    'job-offer-page': 'career',
    'review-page': 'reviews'
  };

  const slugBase = (() => availableSlugs[templateKey])();

  return has(settings, 'slug')
    ? `/${slugBase}/${settings.slug}/`
    : fields.slug;
};

export const getArticleByName = (name, articles) => {
  const article = articles.filter(
    edge => edge.node.frontmatter.title === name,
  );

  return article.length > 0 ? article[0] : null;
};

export const getCloudinaryUrl = (asset, attrs) =>
  asset
    ? `https://res.cloudinary.com/de4rvmslk/image/upload/${attrs}/v1/${asset}`
    : null;

export const toHtml = (markdown, context) => {
  const compile = marksy({
    createElement,
    components: {
      NewsletterSmall,
      RelatedArticle,
      Iframe,
      BlogLink,
      BlogQuoteAuthor,
    },
    elements: {
      img({ src, alt }) {
        // f_auto fetches WebP, if browser allows to do it. File name can remain with .jpg extension, but WebP mime type will be loaded anyway.
        return (
          <img src={getCloudinaryUrl(src, 'f_auto,q_auto,w_700')} alt={alt || ''} />
        );
      },
      iframe({ id, children }) {
        return <div>{children}</div>;
      },
    },
  });

  return compile(markdown, null, context).tree;
};

export const estimateReadTime = text => {
  const wordsPerMinute = 200;

  const base = text.split(' ').length / wordsPerMinute;
  const minutes = Math.floor(base);
  const seconds = (base % 1) * 60;

  return seconds > 30 ? minutes + 1 : minutes;
};

export const getQueryParam = param => {
  const encodedParam = encodeURIComponent(param).replace(/[\.\+\*]/g, '\\$&');
  const regexp = new RegExp(
    `^(?:.*[&\\?]${encodedParam}(?:\\=([^&]*))?)?.*$`,
    'i',
  );
  const foundParam = window.location.search.replace(regexp, '$1');

  return decodeURIComponent(foundParam);
};

export const getUrlSearchParams = location => {
  if (typeof window !== 'undefined') {
    return new window.URLSearchParams(location.search);
  }

  return null;
};

export const findArticleByTitle = (allArticles, value) =>
  allArticles.edges.find(edge => edge.node.frontmatter.title === value);
